import {inject} from '@angular/core';
import {CanActivateFn, CanActivateChildFn, Router} from '@angular/router';
import {UserContextService} from '../../core/services/user-context.service';

export const permissionsGuardFn: CanActivateFn & CanActivateChildFn = (route, state) => {
    let debug = true;
    const userContext = inject(UserContextService);
    const router = inject(Router);

    const requiredPermissions: string[] = route.data?.['permissions'] || [];
    const userPermissions: string[] = userContext.getPermissions();

    const hasAccess = requiredPermissions.some(permission => userPermissions.includes(permission));

    if (debug && !hasAccess) {
        console.log(`Checking access for route: ${state.url}`);
        console.log(`Required permissions: ${requiredPermissions}`);
        console.log(`User permissions: ${userPermissions}`);
        console.warn(`Access granted: ${hasAccess}`);
    }


    if (!hasAccess) {
        router.navigate(['/dashboard?unauthorized=true']);
        return false;
    }

    return true;
};
